import * as React from 'react'
import styled from '../../utils/styled'
import { Separator } from '../../styles/components/separator'

const StyledItemContainer = styled('div')`
  border-radius: 0.5rem;
  background-color: ${props => props.theme.colors.accent};
  & {
    :hover {
      box-shadow: 0 0 10px 3px ${props => props.theme.colors.borders};
    }
    * {
      text-decoration: none;
    }
  }
`

const InnerContainer = styled('div')`
  padding: 1rem 1.5rem;
  margin-bottom: 0.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const ChildrenContainer = styled('div')`
  flex-grow: 1;
`

interface ItemContainerProps {
  onClick?: () => void
  leftContent?: React.ReactNode
  rightContent?: React.ReactNode
  bottomContent?: React.ReactNode
}

export const ItemContainer: React.FC<ItemContainerProps> = ({ children, onClick, leftContent, rightContent, bottomContent }) => {
  return (
    <>
      <StyledItemContainer onClick={onClick}>
        <InnerContainer>
          {leftContent && leftContent}
          <ChildrenContainer>{children}</ChildrenContainer>
          {rightContent && rightContent}
        </InnerContainer>
        {bottomContent && (
          <>
            <Separator />
            <InnerContainer>{bottomContent}</InnerContainer>
          </>
        )}
      </StyledItemContainer>
    </>
  )
}
